import { Params } from 'react-router';
import { managerService, sendManagerEvent } from '../xstate/app.xstate';
import { shouldSelectOrgFromRoute } from './org-path-prefix';

export const syncXstateWithRouteParams = ({
  params,
}: {
  params: Params<string>;
  searchQuery?: URLSearchParams;
}) => {
  const {
    org_id: newOrgId,
    project_id: newProjectId,
    user_id: newUserId,
    team_id: newTeamId,
    environment_id: newEnvironmentId,
    applet_id: newAppletId,
  } = params;

  const managerContext = managerService.getSnapshot().context;

  const { orgId, projectId, userId, teamId, environmentId, appletId } = {
    orgId: managerContext.selectedOrgId,
    projectId: managerContext.selectedProject,
    userId: managerContext.selectedUser,
    teamId: managerContext.selectedTeam,
    environmentId: managerContext.selectedEnvironment,
    appletId: managerContext.selectedApplet,
  };

  if (
    shouldSelectOrgFromRoute({
      routeOrgId: newOrgId,
      selectedOrgId: orgId,
      // The not-found route (`path="*"`) is the only one that has a `*` param.
      isFallbackRoute: params['*'] !== undefined,
    })
  ) {
    sendManagerEvent({
      type: 'manager.selectOrgId',
      orgId: newOrgId,
    });
  }

  if (newProjectId !== projectId) {
    sendManagerEvent({
      type: 'manager.selectProject',
      id: newProjectId,
    });
  }

  if (newUserId !== userId) {
    sendManagerEvent({
      type: 'manager.selectUser',
      id: newUserId,
    });
  }

  if (newTeamId !== teamId) {
    sendManagerEvent({
      type: 'manager.selectTeam',
      id: newTeamId,
    });
  }

  if (newEnvironmentId !== environmentId) {
    sendManagerEvent({
      type: 'manager.selectEnvironment',
      id: newEnvironmentId,
    });
  }

  if (newAppletId && newAppletId !== appletId) {
    sendManagerEvent({
      type: 'manager.selectApplet',
      id: newAppletId,
    });
  }
};
